<template>
	<div class="d-flex align-center flex-1" v-m2-span :style="{ color: colors.fontColor }" v-if="subcontract?.has_all_payments || contract?.last_status?.status == contractStatuses.SUBCONTRATO_ANULADO">
		<div class="flex-1 px-2 py-1">
			<div class="d-flex align-start justify-start item-background-hover" v-if="subcontract_info?.contractor">
				<div class="d-flex align-center caption" v-if="contract">
					<div style="min-width: 250px;width: 300px;">
						<div class="caption d-flex justify-space-between" style="gap: 10px;" :style="{'opacity': annulated ? 0.5 : 1}">
							<div style="font-size:10px;">Subcontrato:</div>
							<p class="mb-0 font-weight-bold caption">{{ contractCode }}</p>
						</div>
						<div class="caption d-flex justify-space-between align-start" style="gap: 10px;">
							<div>
								<div style="font-size:10px;" :style="{'opacity': annulated ? 0.5 : 1}">Subcontratista:</div>
								<div :style="{'opacity': annulated ? 0.5 : 1}" v-if="contract.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES && !hasCurrentSuspensionRequest">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												outlined
												:color="colors.fontColor"
												x-small
												v-bind="attrs"
												v-on="on"
												@click="startStatusRequest('anulation')"
											>
												<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
												<p class="mb-0 ml-2">Suspender</p>
											</v-btn>
										</template>
										<span>Suspende el subcontrato y vuelve a seleccionar al subcontratista para los proyectos incluidos</span>
									</v-tooltip>
								</div>
								<div v-else-if="contract.last_status?.status == contractStatuses.SUBCONTRATO_ANULADO && !hasCurrentSuspensionRequest && !hasSubcontractSigned">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												outlined
												:color="colors.fontColor"
												x-small
												v-bind="attrs"
												v-on="on"
												:style="{'opacity': contract.morphable?.responsible?.id != $store.state.user.id ? 0.5 : 1}"
												@click="startStatusRequest('restauration')"
											>
												<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
												<p class="mb-0 ml-2">Restaurar</p>
											</v-btn>
										</template>
										<span>Restaura el subcontrato, esta acción debe ser aprobada por un usuario con rol de Administrador en la empresa.</span>
									</v-tooltip>
								</div>
								<div v-else-if="contract.last_status?.status == contractStatuses.SUBCONTRATO_ANULADO && hasCurrentSuspensionRequest">
									<v-chip x-small color="success">Restauración Solicitada</v-chip>
								</div>
								<div v-else-if="contract.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES && hasCurrentSuspensionRequest">
									<v-chip x-small color="warning">Suspensión Solicitada</v-chip>
								</div>
							</div>
							<div class="text-right" style="flex: 1; min-width: 0;" :style="{'opacity': annulated ? 0.5 : 1}">
								<p class="mb-0 font-weight-bold caption" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ subContractor || 'Sin Subcontratista' }}</p>
								<p class="mb-0" style="font-size: 10px;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" v-if="subcontract_info?.contractor?.email">{{ subcontract_info.contractor?.email }}</p>
							</div>
						</div>
					</div>
					<v-divider vertical class="mx-4" :style="{ borderColor: colors.fontColor }"></v-divider>
					<div class='d-flex flex-column justify-start align-end flex-1'>
						<div class="d-flex align-center caption flex-1" style="width: 100%;">
							<v-chip
								:color="contract.last_status?.status | contractStatusColor"
								dark
								label
								x-small
								style="width: 100%;"
								class="px-1 my-0 d-flex justify-center align-center"
							>
								<p class="mb-0 font-weight-bold">{{ contract.last_status?.status | contractStatusSubcontractor }}</p>
							</v-chip>
							<ContractAnnulationInfo :contract="contract" v-if="contract.last_status?.status == contractStatuses.SUBCONTRATO_ANULADO || contract.status_requests.length" :color="colors.fontColor"/>
							<!-- <div v-if="contract.last_status?.status == contractStatuses.SUBCONTRATO_ANULADO">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											dark
											small
											color="#959595"
											class="ml-1"
											v-bind="attrs"
											v-on="on"
											@click="showContractDetail(contract)"
										>
											<v-icon size="20">mdi-information-box-outline</v-icon>
										</v-btn>
									</template>
									<span>Ver Información de la anulación del subcontrato</span>
								</v-tooltip>
							</div> -->
						</div>
						<v-divider class="my-2" style="width: 100%;" :style="{ borderColor: colors.fontColor }" v-if="showToContractButton"></v-divider>
						<div class="d-flex align-center justify-space-between" v-if="showToContractButton">
							<div>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											outlined
											:color="colors.fontColor"
											x-small
											v-bind="attrs"
											v-on="on"
											:disabled="!subcontract_info.contractor"
											@click="toContractDetail(contract)"
										>
											<v-icon dark small>mdi-briefcase-plus-outline</v-icon>
											<p class="mb-0 ml-2">Ver el Subcontrato</p>
										</v-btn>
									</template>
									<span>Ver el Subcontrato Existente</span>
								</v-tooltip>
							</div>
							<div>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											dark
											small
											color="#959595"
											class="ml-1"
											v-bind="attrs"
											v-on="on"
											v-if="subcontract_info.subcontract?.contract?.pdf"
											@click="openPdf"
										>
											<v-icon size="20">mdi-file-clock-outline</v-icon>
										</v-btn>
									</template>
									<span>Ver PDF Actual</span>
								</v-tooltip>
							</div>
						</div>
					</div>
				</div>
				<!-- <v-divider vertical class="mx-4" :style="{ borderColor: colors.fontColor }"></v-divider>
				<div class="caption">
					<div style="font-size:10px;">Subcontratista:</div>
					<b class="mb-0" style="flex: 1;">{{ subContractor || 'Sin Subcontratista' }}</b>
					<p class="mb-0" style="font-size: 10px;" v-if="subcontract_info?.contractor?.email">{{ subcontract_info.contractor?.email }}</p>
				</div> -->
			</div>
			<div class="d-flex align-center flex-1" v-m2-span v-else>
				<div class="caption">
					<div style="font-size:10px;">Proyectos sin Subcontratista Asignado</div>
					<b class="mb-0" style="flex: 1;">Por favor selecciona un subcontratista y luego asígnalo al proyecto</b>
				</div>
				<!-- <UserChatSelectorMenu
					:users="subcontractorsForChat"
					:currentUserId="userInfo.id"
					:projectLineId="project?.project_line_info?.project_line_id"
					:projectLineNumber="project?.project_line_info?.project_line?.number"
					:projectName="project?.name"
					tooltipText="Chatear con Subcontratistas Disponibles"
					:excludeCurrentUser="true"
					:excludeProjectLine="true"
					:color="colors.fontColor"
				/> -->
			</div>
		</div>
		<AcceptCancelModal
			:closeModal="closeModalAcceptRejectModal"
			:acceptRejectModal="acceptRejectModal"
			:acceptRejectModalData="acceptRejectModalData"
			:withTextContent="true"
			:textRequired="true"
			textInputLabel="Ingresa un motivo o comentario"
		/>
	</div>
	<div class="d-flex flex-column align-start flex-1" v-m2-span :style="{ color: colors.fontColor }" v-else-if="subcontract_info?.contractor">
		<div class="d-flex align-center flex-1 px-2 py-1" style="gap: 5px;">
			<v-icon :color="colors.fontColor">mdi-badge-account-outline</v-icon>
			<div>
				<!-- <p class="mb-0 font-weight-bold caption">No puedes editar este subcontrato hasta que todos los estados de pago estén configurados.</p>
				<p class="mb-0 font-weight-bold" style="opacity: 0.8;font-size: 11px;">En cada fila, la columna Totales debe ser 100%.</p>
				<v-divider class="my-1" :style="{ borderColor: colors.fontColor }"></v-divider> -->
				<p class="mb-0 font-weight-bold caption" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ subContractor || 'Sin Subcontratista' }}</p>
				<p class="mb-0" style="font-size: 10px;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" v-if="subcontract_info?.contractor?.email">{{ subcontract_info.contractor?.email }}</p>
			</div>
		</div>
	</div>
	<div class="d-flex align-center flex-1" v-m2-span :style="{ color: colors.fontColor }" v-else>
		<div class="d-flex align-center justify-space-between flex-1 px-2 py-1" style="gap: 5px;">
			<div>
				<div class="caption">
					<div style="font-size:10px;">Proyectos sin Subcontratista Asignado</div>
					<b class="mb-0" style="flex: 1;">Por favor selecciona un subcontratista y luego asígnalo al proyecto</b>
				</div>
			</div>
			<!-- <UserChatSelectorMenu
				:users="subcontractorsForChat"
				:currentUserId="userInfo.id"
				:projectLineId="project?.project_line_info?.project_line_id"
				:projectLineNumber="project?.project_line_info?.project_line?.number"
				:projectName="project?.name"
				tooltipText="Chatear con Subcontratistas"
				:excludeCurrentUser="true"
				:color="colors.fontColor"
			/> -->
		</div>
	</div>
</template>

<script>
import contractStatuses from '@/components/Helpers/Constants/contract.js'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import AcceptCancelModal from '@/components/Modals/General/AcceptCancelModal'
import ContractAnnulationInfo from '@/components/Views/Projects/SettingsParts/ContractAnnulationInfo'
import {contractStatusRequest} from '@/helpers/api/contracts'
// import UserChatSelectorMenu from '@/components/Helpers/Components/UserChatSelectorMenu'

export default {
	name: 'ContractorInfo',
	components: { AcceptCancelModal, ContractAnnulationInfo },
	props: {
		costsTable: {
			type: Object,
			required: true
		},
		subcontract: {
			type: [Object, null],
			required: false
		},
		project: {
			type: Object,
			required: true
		},
		main_contract: {
			type: Object,
			required: false
		},
		annulated: {
			type: Boolean,
			required: false,
			default: false
		},
		showToContractButton: {
			type: Boolean,
			default: true
		},
		colors: {
			type: Object,
			required: false,
			default: () => ({
				background: '#FFFFFF',
				fontColor: '#000000'
			})
		}
	},
	computed: {
		userInfo() {
			return this.$store.state.user.userInfo
		},
		hasCurrentSuspensionRequest(){
			if(this.contract.status_requests.length){
				return this.contract.status_requests[0].type == 1 && this.contract.status_requests[0].status === 0
			}
			return false
		},
		hasCurrentRestorationRequest(){
			if(this.contract.status_requests.length){
				return this.contract.status_requests[0].type == 1 && this.contract.status_requests[0].status === 0
			}
			return false
		},
		hasSubcontractSigned(){
			const item_type = this.subcontract?.subcontract_info?.item_type
			const item_id = this.subcontract?.subcontract_info?.item_id
			if(item_type == 'stage' || item_type == 'specialty'){
				const type_name = item_type == 'stage' ? 'stages':'specialties'
				return this.costsTable.subcontracts_info[type_name].some((item) => {
					return item.item_id == item_id && item.subcontract?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES
				})
			}
			return this.costsTable.subcontracts_info[item_type]?.item_id == item_id &&
							this.costsTable.subcontracts_info[item_type]?.subcontract?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES
		},
		hasSubcontractPreparation(){
			const item_type = this.subcontract?.subcontract_info?.item_type
			const item_id = this.subcontract?.subcontract_info?.item_id
			if(item_type == 'stage' || item_type == 'specialty'){
				const type_name = item_type == 'stage' ? 'stages':'specialties'
				return this.costsTable.subcontracts_info[type_name].some((item) => {
					return item.item_id == item_id
				})
			}
			return this.costsTable.subcontracts_info[item_type]?.item_id == item_id
		},
		subcontract_info(){
			return this.subcontract.subcontract_info
		},
		contractCode() {
			const contract = this.contract
			if(this.main_contract){
				let append = ''
				if(contract.addendum_to_contract_id){
					append = ` - ANX Nº ${contract.addendum_index}`
				}
				else if(contract.subcontract_to_contract_id){
					append = ` - SUB Nº ${contract.subcontract_index}`
				}
				return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${this.main_contract?.info?.contract_prefix_index} ${append}`
			}
			return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.info?.contract_prefix_index}`
		},
		subContractor(){
			if(this.subcontract_info?.contractor?.profile){
				return this.subcontract_info?.contractor?.profile?.name + ' ' + this.subcontract_info?.contractor?.profile?.lastname + ' ' + this.subcontract_info?.contractor?.profile?.second_lastname	
			}
			return 'Sin Subcontratista'
		},
		contract(){
			return this.subcontract?.subcontract?.contract || this.subcontract?.annulated_subcontract?.contract || this.subcontract_info?.subcontract?.contract || this.subcontract_info?.annulated_subcontract?.contract
		},
		subcontractorList(){
			return this.$store.state.users.usersList.filter(user => {
				return user.company_rol?.capabilities?.subcontractor === true
			})
		},
		subcontractorsForChat(){
			return this.subcontractorList.map(user => {
				return {
					...user,
					userType: 'subcontractor'
				}
			})
		}
	},
	data() {
		return{
			contractStatuses,
			acceptRejectModal: false,
			acceptRejectModalData: null
		}
	},
	mounted(){
	},
	methods: {
		toContractDetail(contract){
			// this.$store.commit('contracts/setSubcontractComponentModalId', contract.id)
			window.open(
				`/built-in-content?type=subcontract&id=${contract.id}`,
				'',
				'width=1000,height=700,toolbar=no,menubar=no,location=no,status=no'
			);
		},
		openPdf(){
			console.log('subcontract_info?.subcontract?.contract.pdf', this.subcontract_info?.subcontract?.contract.pdf)
			const file_link = this.subcontract_info?.subcontract?.contract?.pdf?.file?.file_link
			if(file_link){
				window.open(
					file_link,
					'',
					'width=1000,height=700,toolbar=no,menubar=no,location=no,status=no'
				);
			}
		},
		buildRequestModal({
			type,
			actionLabel,
			actionVerb,
			extraWarningHtml = ''
		}) {
			return {
				type,
				title: `Solicitud de ${actionLabel} de subcontrato`,
				html_content: true,
				content_a: `
					<div style="display:flex; flex-direction:column; gap:16px; font-size:14px; color:#333;">
						
						<p style="margin:0;">
							Estás a punto de <strong>enviar una solicitud para ${actionVerb}</strong> este subcontrato.
						</p>

						<div style="background:#f5f7fa; padding:12px; border-radius:6px;">
							<p style="margin:0;">
								Esta solicitud deberá ser <strong>revisada y autorizada</strong> por un usuario que cuente con los permisos necesarios.
							</p>
						</div>

						${extraWarningHtml}

						<p style="margin:0;">
							Una vez enviada, el proceso quedará pendiente de aprobación y no se aplicarán cambios hasta que sea autorizada.
						</p>

						<p style="margin:0; font-weight:600;">
							¿Deseas continuar con el envío de la solicitud?
						</p>

					</div>
				`
			}
		},
		startStatusRequest(type = 'anulation') {
			if (this.project?.responsible?.id !== this.$store.state.user?.userInfo?.id) {
				this.setMessage({
					message: 'Sólo el responsable del proyecto puede ingresar esta solicitud.',
					title: 'Acción no permitida',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				})
				return
			}

			const preparationWarning = this.hasSubcontractPreparation && type == 'restauration'
				? `
					<div style="background:#fff4e5; padding:12px; border-radius:6px; border:1px solid #ffd9a0;">
						<p style="margin:0;">
							Actualmente se está <strong>preparando un subcontrato con otro contratista</strong> para este proyecto.
						</p>
						<p style="margin:8px 0 0 0;">
							En caso de que esta solicitud sea aprobada, 
							<strong>cualquier negociación activa con otro contratista será descartada automáticamente</strong>.
						</p>
					</div>
				`
				: ''

			this.acceptRejectModalData = this.buildRequestModal({
				type,
				actionLabel: type == 'anulation' ? 'suspensión':'restauración',
				actionVerb: type == 'anulation' ? 'suspender':'restaurar',
				extraWarningHtml: preparationWarning
			})

			this.acceptRejectModal = true
		},
		closeModalAcceptRejectModal(data, confirmationText){
			if(data && this.acceptRejectModalData?.type == 'anulation'){
				this.requestContractStatus(confirmationText, 1)
			}
			else if(data && this.acceptRejectModalData?.type == 'restauration'){
				this.requestContractStatus(confirmationText, 2)
			}
			this.acceptRejectModalData = null
			this.acceptRejectModal = false
		},
		async requestContractStatus(observation, type){
			const contract = await contractStatusRequest({contract_id: this.contract.id, observation, type})
			if(contract.code == 200){
				eventBus.$emit('reloadInformation')
			}
		},
		showContractDetail(contract){
			console.log('Show contract detail', contract)
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
	}
}
</script>